// User types
export const SET_USER = "SET_USER";
// Contract types
export const SET_LATEST_CONTRACT = "SET_LATEST_CONTRACT";
// Organisation types
export const SET_ORGANISATION = "SET_ORGANISATION";
